import React from 'react';
import {Box, IconButton} from '@mui/material';
import {ReactComponent as DeleteIcon} from '../../assests/svg/delete-icon.svg';
import {ReactComponent as EditIcon} from '../../assests/svg/edit-icon.svg';
import {t} from 'i18next';

type IconButtonGroupProps = {
  onEdit: (event: React.MouseEvent) => void;
  onDelete: (event: React.MouseEvent) => void;
  disableEdit?: boolean;
  disableDelete?: boolean;
};

const buttonStyles = {
  '&:hover': {
    backgroundColor: 'transparent',
    boxShadow: 'none',
  },
};

const AurTileButtonGroup: React.FC<IconButtonGroupProps> = ({
  onEdit,
  onDelete,
  disableEdit = false,
  disableDelete = false,
}) => (
  <Box className="summary-button-group">
    <IconButton
      aria-label={t('buttons.delete')}
      disabled={disableDelete}
      onClick={onDelete}
      sx={buttonStyles}
      data-testid="delete-button"
    >
      <DeleteIcon aria-hidden="true" />
    </IconButton>
    <IconButton
      aria-label={t('buttons.edit')}
      disabled={disableEdit}
      onClick={onEdit}
      sx={buttonStyles}
      data-testid="edit-button"
    >
      <EditIcon aria-hidden="true"/>
    </IconButton>
  </Box>
);

export default AurTileButtonGroup;
